<!--
 * @Description: 客户案例页面
 * @Author: wushuang
 * @LastEditors: youme
 * @Date: 2020-07-05 14:33:08
 * @LastEditTime: 2023-06-06 14:24:01
-->
<template>
  <Container>
    <div class="product-body">
      <img class="banner hidden-md-and-down" :src="banner" alt="banner">
      <img class="banner hidden-lg-and-up" :src="bannerPhone" alt="bannerPhone">
      <div class="main-body container">
        <div class="carouse-items">
          <div v-for="item in caseList" :key="item.id" class="carouse-item">
            <img :src="`/picture/${item.img1}`" alt="carouse2">
            <div class="item-title">
              {{ item.subject1 }}
            </div>
            <div class="item-text" v-html="item.description1.replace(new RegExp('\n', 'gm'), '<br>')" />
            <div class="item-foot">
              <div class="foot-text" @click="handleJumpByUrl(`/customercase-detail/${item.id}`)">查看详情</div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-layout">
        <Pagination
          hide-on-single-page
          background
          layout="pager"
          :total="totalElements"
          :current-page="currentPage"
          :page-size="3"
          :pager-count="5"
          @current-change="handleCurrentChange"
        />
      </div>
      <div class="foot-up hidden-md-and-down">
        <div class="container">
          <Row :gutter="24">
            <Cell :lg="{span:12}">
              <div class="text-position">
                有问题吗？<br>
                我们的销售代表会为您解答。
              </div>
              <div class="item-text">您可以联系我们</div>
              <div class="item-text">销售热线：15754006669/0411-39516699</div>
              <div class="item-text">售后服务：15754006667/0411-39516676</div>
              <div class="item-text">您还可以发送邮件至market@haosen.com.cn</div>
              <div class="item-text">进行咨询</div>
              <Button @click="handleJumpByUrl('/contact')">联系我们</Button>
            </Cell>
            <Cell :lg="{span:12}">
              <img :src="person" alt="person">
            </Cell>
          </Row>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from '@/components/Container'
import person from '@/assets/product/person.png'
import { Row, Col, Button, Pagination } from 'element-ui'
import { getCustomerCase } from '../../api'
import banner from '@/assets/customercase/banner.jpeg'
import bannerPhone from '@/assets/customercase/bannerPhone.jpeg'

export default {
  name: 'CutomerCase',
  components: { Row, 'Cell': Col, Button, Container, Pagination },
  data: function() {
    return {
      person,
      caseList: [],
      totalElements: 0,
      currentPage: 1,
      banner,
      bannerPhone
    }
  },
  created() {
    this.fetchCustomerCase({})
  },
  methods: {
    handleJumpByUrl(url) {
      this.$router.push({ path: url })
    },
    fetchCustomerCase({ pageSize = 3, currentPage = 1 }) {
      getCustomerCase({
        pageSize,
        currentPage
      }).then(response => {
        this.caseList = response.data.content
        this.totalElements = response.data.totalElements
        this.currentPage = currentPage
      })
    },
    handleCurrentChange(currentPage) {
      if (document.body.clientWidth < 1200) {
        window.scrollTo(0, 0)
      }
      this.fetchCustomerCase({ currentPage })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.product-body {
  position: relative;
  .banner {
    position: relative;
    left: 50%;
    margin-left: -960px;
  }
  .main-body {
    background-color: #f4f4f4;
    padding-top: 90px;
    .carouse-items {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
      .carouse-item {
        width: 320px;
        background-color: #fff;
        box-shadow: 30px 30px 30px -24px #e8e9ec;
        border-radius: 30px;
        overflow: hidden;
        padding-bottom: 40px;
        img {
          width: 100%;
        }
        .item-title {
          @include secondTitle;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          color: #000;
          padding-bottom: 0;
          margin: 40px 30px;
        }
        .item-text {
          @include normalText;
          padding: 0 30px;
          line-height: 30px;
          height: 390px;
        }
        .item-foot {
          margin-top: 20px;
          width: 65px;
          margin-left: 30px;
          border-top: 1px solid #c6c6c6;
          .foot-text {
            color: #3e3892;
            margin-top: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .pagination-layout {
    text-align: center;
    padding-top: 97px;
    padding-bottom: 102px;
    /deep/ .active {
      border-radius: 15px;
    }
  }
  .foot-up {
    height: 595px;
    background-color: #3e3892;
    .text-position {
      @include title;
      color: white;
      font-weight: bolder;
      line-height: 60px;
      padding-top: 74px;
    }
    .item-text{
      @include normalText;
      line-height: 32px;
      color:white;
    }
    /deep/ .el-button {
      margin-top: 86px;
    }
    img {
      margin-top: -44px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .product-body {
    .banner {
      width: 100%;
      left: 0;
      margin-left: 0;
    }
    .main-body {
      padding-top: 30px;
      .carouse-items {
        justify-content: center;
        .carouse-item + .carouse-item {
          margin-top: 30px;
        }
        .carouse-item {
          .item-title {
            margin: 10px 30px 0;
          }
          .item-text {
            height: auto;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
        }
        .item-text {
          height: 316px;
        }
      }
    }
    .pagination-layout {
      padding-top: 20px;
      padding-bottom: 30px;
    }
  }
}
</style>
